<template>
  <div class="team-performance-box">
    <div class="team-performance">
      <div class="team-statistics-title">团队业绩统计</div>
      <ul class="team-performance-nav">
        <li
          v-for="(item,index) in liList"
          :key="index"
          :class="isLink==item.type ? 'li-style li-check-style' : 'li-style'"
          @click="chooseLi(item,index)"
        >{{item.name}}</li>
      </ul>
      <div class="team-performance-data">
        <div class="data-title-box">
          <div class="performance-data-title" v-for="item in titleList1" :key="item">{{item}}</div>
        </div>
        <div class="performance-data-list" v-for="(item,index) in teamLoanData" :key="index">
          <div class="performance-data-value">{{item.info}}</div>
          <div class="performance-data-value">{{item.todayHas}}</div>
          <div class="performance-data-value">{{item.thisMonth}}</div>
          <div class="performance-data-value">{{item.thisYear}}</div>
        </div>
      </div>
    </div>
    <div class="team-performance">
      <div class="team-statistics-title title2">个人业绩统计</div>
      <ul class="team-performance-nav">
        <li
          v-for="(item,index) in liList2"
          :key="index"
          :class="isLink2==item.type ? 'li-style li-check-style' : 'li-style'"
          @click="chooseLi2(item,index)"
        >{{item.name}}</li>
      </ul>
      <div class="team-performance-data">
        <div class="data-title-box">
          <div class="performance-data-title" v-for="item in titleList2" :key="item">{{item}}</div>
        </div>
        <div class="performance-data-list" v-for="(item,index) in performanceData" :key="index">
          <div class="performance-data-value">{{item.info}}</div>
          <div class="performance-data-value">{{item.todayHas}}</div>
          <div class="performance-data-value">{{item.thisMonth}}</div>
          <div class="performance-data-value">{{item.thisYear}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data() {
    return {
      isLink: 'loan',//团队业绩 贷款、保险选中
      liList: [
        { type: 'loan', name: '贷款' },
        { type: 'insurance', name: '保险' },
      ],
      isLink2: 'loan',//团队业绩 贷款、保险选中
      liList2: [
        { type: 'loan', name: '贷款' },
        { type: 'insurance', name: '保险' },
      ],
      titleList1: ["团队业绩", "今日", "本月", "本年"],
      titleList2: ["个人业绩", "今日", "本月", "本年"],
      performanceData: [],
      teamLoanData:[]
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    chooseLi(v, i) {
      this.isLink = v.type
      this.getData()
    },
    chooseLi2(v, i) {
      this.isLink2 = v.type
      this.getData()
    },
    getData() {
      let data = {
        userId: localStorage.getItem('userid'),
        type: this.isLink,
        agentPhone: localStorage.getItem('phone'),
      }
      this.$fetchGet(URL.teamAchievement.url, data).then(res => {
        this.performanceData = res.data.data.personalLoanData
        this.teamLoanData = res.data.data.teamLoanData
      })
    }
  }
}
</script>

<style lang="less" scoped>
.team-performance-box {
  width: 355px;
  margin: auto;
  padding-bottom: 21px;
  font-family: Source Han Sans CN;
  border-collapse: collapse;
}
.team-performance {
  // height: 306.5px;
  .team-performance-nav {
    display: flex;
    margin-top: 10px;
    .li-style {
      width: 75px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      color: #333333;
      font-weight: 400;
      background: url("./img/li-bg1.png") no-repeat 50%;
      background-size: 100% 100%;
      &:last-child {
        margin-left: 10px;
      }
    }
    .li-check-style {
      background: url("./img/li-bg2.png") no-repeat 50%;
      background-size: 100% 100%;
      font-weight: 500;
      color: #ffffff;
    }
  }
  .team-statistics-title {
    font-size: 13px;
    font-weight: 500;
    color: #333333;
  }
  .title2 {
    margin-top: 20px;
  }
}
.team-performance-data {
  width: 355px;
  margin-top: 10px;
  text-align: center;
  .data-title-box {
    display: flex;
    border-bottom: none;
  }
  .performance-data-title {
    width: 60px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    font-weight: Medium;
    color: #333333;
    border: 1px solid #d4d4d4;
    background-color: #f2f2f2;
    width: calc(355px - 240px);
    &:not(:first-child) {
      width: 80px;
    }
    &:not(:last-child) {
      border-right: none;
    }
  }
  .performance-data-list {
    display: flex;
    // justify-content: space-around;
    text-align: center;
    font-size: 12px;
    .performance-data-value {
      width: calc(355px - 240px);
      height: 30px;
      line-height: 30px;
      background: #ffffff;
      border: 1px solid #d4d4d4;
      border-top: none;
      &:not(:first-child) {
        width: 80px;
      }
      &:not(:last-child) {
        border-right: none;
      }
    }
  }
  .performance-data-list:last-child {
    border: none;
    align-items: center;
  }
}
.tab-sty {
  width: 100%;
  margin-top: 10px;
  border-collapse: collapse;
  color: #666666;
  th {
    font-size: 13px;
    font-weight: 500;
    background-color: #f2f2f2;
    &:not(:first-child) {
      width: 80px;
    }
  }
  td {
    font-size: 12px;
    font-weight: 400;
  }
  th,
  td {
    height: 30px;
    text-align: center;
    border: 1px solid #d4d4d4;
  }
}
</style>